<template>
  <template v-if="isViewComponent()">
    <div>
      <Select @changeVal="changeMainSelect" :payload="{
        items: getMainItems(),
        label: 'Выберите категорию',
        category_id: getPayloadCategoryId(),
      }"/>
    </div>
    <div class="mt-2" v-if="isViewChild()">
      <label class="form-label">Уточните категорию KKTU:</label>
      <SelectKktu @changeVal="changeChildSelect" :payload="{
        items: getChildItems(),
        label: 'Выберите категорию KKTU',
      }"/>
    </div>
  </template>
  <template v-else>
    <div class="page-body">
      <div class="spinner-border spinner-border-sm me-2"></div>
    </div>
  </template>
</template>

<script>
import {defineComponent, onMounted, reactive, ref} from "vue"

import Select from "../../components/select/Index"
import SelectKktu from "../../components/select_kktu/Index"
import Api from "./services/Api"
import Notify from "@/services/Notify"
import CatalogImage from '@/modules/catalog/services/Image'

export default defineComponent({
  name: "GroupSelect",
  components: {
    Select,
    SelectKktu,
  },
  emits: ['changeVal'],
  props: {
    payload: {
      type: Object,
      required: true
    },
  },
  setup(props, {emit}) {
    let categoriesValues = ref([])
    let subCategoriesValues = ref([])
    let viewChild = ref(false)
    let loadCategories = ref(false)

    const payload = reactive({
      post_id: null,
      shop_id: null,
      category_id: null,
    })

    onMounted(() => {
      updatePayload(props.payload)

      unmarkLoadCategories()
      fetchCategories().then(() => {
        markLoadCategories()
      })
    })

    function updatePayload(query) {
      payload.post_id = query.post_id
      payload.shop_id = query.shop_id
      payload.category_id = query.category_id
    }

    function getPayloadPostId() {
      return payload.post_id
    }

    function getPayloadCategoryId() {
      return payload.category_id
    }

    function getMainItems() {
      return categoriesValues.value
    }

    function getChildItems() {
      return subCategoriesValues.value
    }

    function markLoadCategories() {
      loadCategories.value = true
    }

    function unmarkLoadCategories() {
      loadCategories.value = false
    }

    function isLoadCategories() {
      return loadCategories.value === true
    }

    function markViewChild() {
      viewChild.value = true
    }

    function unmarkViewChild() {
      viewChild.value = false
    }

    function isViewChild() {
      return viewChild.value === true
    }

    function getPayloadShopId() {
      return payload.shop_id
    }

    function changeMainSelect(val) {
      unmarkViewChild()

      setSubCategories([])
      pushParent(getPayloadShopId(), null)

      let categoryId = val["category_id"]

      if (categoryId === undefined) {
        return false
      }

      Api.categoryInfo(categoryId).then(async (resp) => {
        if (resp["item"] === null) {
          await setSubCategories([])

          pushParent(getPayloadShopId(), null)
          markViewChild()

          Notify.error("У выбранной категории отсутствует привязка к ККТУ")

          return false
        }

        let kktu = resp["item"]["kktu"]
        let countSeparator = kktu.split(".").length - 1

        // это последний уровень вложенности категории
        // пример 1.2.3 - две точки
        if (countSeparator === 2) {
          pushParent(getPayloadShopId(), kktu)

          return false
        }

        // пробуем получить подкатегории kktu
        Api.categoryKktu(kktu).then(async (resp) => {
          let items = resp["items"]

          let categories = []
          Object.values(items).forEach(val => {
            categories.push({
              value: val["code"],
              title: val["name"],
              path: val["str_path"],
              level: val["level"],
            })
          })

          await setSubCategories(categories)

          markViewChild()
        })
      })
    }

    function changeChildSelect(val) {
      pushParent(getPayloadShopId(), val["category_id"])
    }

    function pushParent(shopId, categoryId) {
      emit("changeVal", getResult(shopId, categoryId))
    }

    function getResult(shopId, categoryId) {
      return {
        shop_id: shopId,
        category_id: categoryId,
      }
    }

    async function setSubCategories(items) {
      subCategoriesValues.value = items
    }

    async function fetchCategories() {
      await Api.categories().then((resp) => {
        let items = resp.data["items"]

        // Сначала мапа по ID
        const categoryMap = {};
        items.forEach(cat => {
          categoryMap[cat.category_id] = { ...cat, children: [] }
        });

        // Строим дерево
        const result = []
        items.forEach(cat => {
          if (cat["category_parent_id"] === 0) {
            result.push(categoryMap[cat["category_id"]])
          } else {
            const parent = categoryMap[cat["category_parent_id"]]
            if (parent) {
              parent.children.push(categoryMap[cat["category_id"]])
            }
          }
        });

        // Собираем дерево с уровнями и отступами
        function collectWithIndent(categories, level = 0, result = []) {
          categories.forEach(cat => {
            const indent = "".repeat(level) // два неразрывных пробела на уровень

            let image = CatalogImage.handle(cat["category_image_host"], cat["category_image_name"], 60, 60)

            result.push({
              value: cat["category_id"],
              title: indent + cat["category_name"],
              image: image,
              path: cat["category_str_path"].replaceAll("###", "/"),
              level: cat["category_level"],
            });

            if (cat.children && cat.children.length > 0) {
              collectWithIndent(cat.children, level + 1, result)
            }
          })

          return result
        }

        categoriesValues.value = collectWithIndent(result)
      })
    }

    function isViewComponent() {
      return isLoadCategories()
    }

    return {
      changeMainSelect,
      changeChildSelect,
      getPayloadPostId,
      getMainItems,
      getChildItems,
      isViewChild,
      isViewComponent,
      getPayloadCategoryId,
    }
  }
})
</script>
